/* eslint-disable indent */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import {
  CheckBox,
  ContentCopy,
  EventRepeat,
  ExpandLess,
  ExpandMore,
  Update,
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Icon,
  IconButton,
  ListItemIcon,
  ListSubheader,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  getEvent,
  patchEvent,
} from '@pingum/app-state-management/event/actions';
import { editEventStatus } from '@pingum/app-state-management/eventStatus/actions';

import { MobileDatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { setGlobalModals } from '../../../redux/app/actions';
import { changeEventStatus } from '../../../redux/event/actions';
import { getErrorMessage } from '../../../redux/networkDispatcher';
import {
  SCHEDULE_MODAL_TYPE,
  TASK_MODAL_TYPE,
} from '../../../redux/app/types';
import {
  addScheduleException,
  deleteSchedule,
  updateSchedule,
} from '../../../redux/schedule/actions';
import { toMomentValue } from '../../../utils/dateHelper';
import {
  getBarnUsersForAssignmentString,
  getScheduleExceptionScheduleReplacementObject,
  getScheduleSeriesText,
} from '../../../utils/scheduleHelper';
import BarnUsersAutocomplete from '../../Autocompletes/BarnUsers';
import TagList from '../../TagList';

const getTaskContext = (props) => `${props.selectedBarn?.tenant}:${props.selectedBarn?.id}:${props.selectedEvent?.id}`;

export class EventActionsMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      element: null,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      sendInvitationNotifications: true,
      copyTask: false,
      dialogType: 'more',
      savingTask: false,
      mutationError: null,
    };
    this.taskMutationPending = false;
    this.mounted = false;
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(previousProps) {
    if (getTaskContext(previousProps) !== getTaskContext(this.props)) {
      this.taskMutationPending = false;
      this.activeMutation = null;
      this.setState({
        savingTask: false,
        mutationError: null,
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  runTaskMutation = async (request, includeStatus = false, closeGlobalModal = false) => {
    if (this.taskMutationPending || this.props.isUpdatingEvent || this.props.mutationDisabled) return;
    const task = this.props.selectedEvent;
    const context = getTaskContext(this.props);
    const mutation = {};
    this.activeMutation = mutation;
    const isCurrent = () => this.mounted && this.activeMutation === mutation && getTaskContext(this.props) === context;
    const statusId = request.completeEvent
      ? this.props.selectedBarn.barnMetadata.statusEndId
      : this.props.selectedBarn.barnMetadata.statusPendingId;
    this.taskMutationPending = true;
    this.props.onMutationChange(true);
    this.setState({
      savingTask: true,
      mutationError: null,
    });
    try {
      await this.props.patchEvent(task.id, request);
      if (!isCurrent()) return;
      if (includeStatus) {
        await this.props.changeStatus(task.id, {
          statusId: parseInt(statusId, 10),
          statusComment: null,
          completeEvent: request.completeEvent,
          assignment: (task.currentEventStatus && task.currentEventStatus.assignment) || '',
        });
      }
      if (isCurrent()) {
        this.taskMutationPending = false;
        this.props.onMutationChange(false);
        this.handleClose(closeGlobalModal);
        if (closeGlobalModal) this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }
    } catch (error) {
      if (isCurrent()) {
        this.setState({
          mutationError: getErrorMessage({
            error,
            defaultErrorMessage: 'Unable to update the task. Please try again.',
          }),
        });
      }
    } finally {
      if (isCurrent()) {
        if (this.taskMutationPending) this.props.onMutationChange(false);
        this.taskMutationPending = false;
        this.activeMutation = null;
        this.setState({ savingTask: false });
      }
    }
  };

  handleOpen = (e, dialogType) => {
    this.setState({
      open: true,
      element: e.currentTarget,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      sendInvitationNotifications: true,
      dialogType,
      copyTask: false,
    });
  }

  handleClose = (reload) => {
    if (this.taskMutationPending) return;
    // If there as a callback, call here first
    if (reload && this.props.modalCallback) {
      this.props.modalCallback(true)
    }
    this.setState({
      open: false,
      element: null,
      confirmCancelOccurrence: true,
      confirmCancelSeries: false,
      confirmEndSeries: false,
      deleteOtherTasks: false,
      sendInvitationNotifications: true,
      dialogType: 'more',
      copyTask: false,
    });
    if (reload && this.props.selectedEvent && this.props.selectedEvent.id) {
      this.props.getEvent(this.props.selectedEvent.id)
    }
    this.props.onClose();
  }

  handleArchiveEvent = (request) => this.runTaskMutation(request);

  handleEventStatus = (request) => this.runTaskMutation(request, true);

  hasInvitationParticipants = () => !!(
    this.props.selectedSchedule
    && this.props.selectedSchedule.assignment
    && this.props.selectedSchedule.assignment.length > 0
  );

  getSkipInvitationNotifications = () => (this.props.selectedSchedule
    && this.props.selectedSchedule.type === 'Invitation'
    && this.hasInvitationParticipants()
    ? !this.state.sendInvitationNotifications
    : false);

  getOccurrenceStartDate = () => {
    const occurrenceDate = (this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start)
      || (this.props.selectedEvent && this.props.selectedEvent.start)
      || (this.props.selectedEvent && this.props.selectedEvent.startDate);
    if (occurrenceDate) {
      return new Date(occurrenceDate);
    }
    return null;
  }

  getScheduleWorkflowCount = () => {
    const workflowCount = (this.props.selectedSchedule
      && this.props.selectedSchedule.workflows
      && this.props.selectedSchedule.workflows.length) || 0;
    return Math.max(workflowCount, this.props.eventTasks.length);
  }

  getSelectedEventTagIds = () => ((this.props.selectedEvent && this.props.selectedEvent.tags) || [])
    .map((tag) => `${tag.id}`);

  selectedEventMatchesWorkflow = (workflow) => {
    const selectedEventTagIds = this.getSelectedEventTagIds();
    return (workflow.tagIds || []).some((tagId) => selectedEventTagIds.includes(`${tagId}`));
  }

  getSelectedScheduleWorkflowMatches = () => {
    if (!this.props.selectedSchedule
      || !this.props.selectedSchedule.workflows
      || !this.props.selectedEvent
      || !this.props.selectedEvent.tags) {
      return [];
    }
    return this.props.selectedSchedule.workflows.filter(this.selectedEventMatchesWorkflow);
  }

  canDeleteSingleWorkflow = () => this.getScheduleWorkflowCount() > 1
    && this.getSelectedScheduleWorkflowMatches().length === 1;

  handleConfirmDeleteOccurrence = () => {
    if (this.taskMutationPending || this.props.mutationDisabled) return;
    const isSingleOccurrence = this.props.selectedSchedule && !this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.endDate
      && new Date(this.props.selectedSchedule.startDate).getTime() === new Date(this.props.selectedSchedule.endDate).getTime()
    const isScheduleException = this.props.selectedSchedule
      && this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id;
    const deleteOtherTasks = this.state.deleteOtherTasks === true || this.state.deleteOtherTasks === 'true';
    const occurrenceStartDate = this.getOccurrenceStartDate() || new Date();
    const hasMultipleTasksOrWorkflows = this.props.selectedSchedule && this.getScheduleWorkflowCount() > 1;
    const onlyRemoveSelectedTask = hasMultipleTasksOrWorkflows
      && this.canDeleteSingleWorkflow()
      && !deleteOtherTasks;

    // No schedule associated so just archive this event
    if (!this.props.selectedSchedule || !this.props.selectedSchedule.id) {
      this.runTaskMutation({ archived: true }, false, true);
    } else if ((isSingleOccurrence || isScheduleException) && !onlyRemoveSelectedTask) {
      // We can delete the entire schedule
      this.props.deleteSchedule(this.props.selectedSchedule.id).then(() => {
        // If there as a callback, call here first
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if ((isScheduleException || isSingleOccurrence) && onlyRemoveSelectedTask && this.props.selectedEvent) {
      // We are only removing one task/workflow from a group of multiple
      // TODO right now we only allow this on created events (not future/scheduled)
      this.props.updateSchedule(this.props.selectedSchedule.id, {
        workflows: this.props.selectedSchedule.workflows
          .filter((w) => !this.selectedEventMatchesWorkflow(w)),
      }, this.getSkipInvitationNotifications()).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if ((!isSingleOccurrence && !isScheduleException) && !onlyRemoveSelectedTask) {
      // Add schedule exception to cancel occurrence
      this.props.addScheduleException(this.props.selectedSchedule.id, {
        exceptionDate: occurrenceStartDate,
        reason: 'Canceled occurrence',
      }, this.getSkipInvitationNotifications()).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete this schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    } else if (!isSingleOccurrence && !isScheduleException && onlyRemoveSelectedTask && this.props.selectedEvent) {
      // Add schedule exception to remove single workflow
      this.props.addScheduleException(this.props.selectedSchedule.id, {
        exceptionDate: occurrenceStartDate,
        reason: 'Rescheduled occurrence',
        exceptionSchedule: {
          ...getScheduleExceptionScheduleReplacementObject(occurrenceStartDate, this.props.selectedSchedule),
          workflows: this.props.selectedSchedule.workflows
            .filter((w) => !this.selectedEventMatchesWorkflow(w)),
        },
      }, this.getSkipInvitationNotifications()).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete this schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
    }
  };

  handleConfirmDeleteSeries = () => {
    this.props.deleteSchedule((this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id)
      || this.props.selectedSchedule.id).then(() => {
        this.handleClose(true);
        this.props.setGlobalModals(null, null, null, null, {}, () => { });
      }).catch((error) => {
        alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
        console.error(error);
      });
  }

  handleConfirmEndSeries = () => {
    this.props.updateSchedule(
      (this.props.selectedSchedule.parentSchedule && this.props.selectedSchedule.parentSchedule.id) || this.props.selectedSchedule.id,
      {
        endDate: (this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start
          && moment(this.props.selectedScheduleEvent.start).add('-1', 'hours').toDate()) || new Date(),
      },
      this.getSkipInvitationNotifications(),
    ).then(() => {
      this.handleClose(true);
      this.props.setGlobalModals(null, null, null, null, {}, () => { });
    }).catch((error) => {
      alert(error.message || 'There was an error attempting to delete the schedule occurrence. Please contact Questri support.');
      console.error(error);
    });
  }

  copyDateClick = (newValue) => {
    if (this.taskMutationPending || this.props.mutationDisabled) return;
    const startDate = this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start;
    const ogDate = moment(startDate);
    const rescheduleDate = moment(newValue.toDate()).add(ogDate.hours(), 'hours').add(ogDate.minutes(), 'minutes').toDate();

    let locationId = null;
    // need to find the location so we can open the calendar event modal
    const locationTag = (this.props.selectedEvent.tags
      || this.props.selectedSchedule.tags).find((t) => t.tagType.id === this.props.selectedBarn.barnMetadata.locationTagTypeId)
    const eventTypeTag = (this.props.selectedEvent.tags
      || this.props.selectedSchedule.tags).find((t) => t.id === this.props.selectedBarn.barnMetadata.eventTaskTypeTagId)
    locationId = (eventTypeTag && (locationTag && locationTag.id)) || null;
    this.props.setGlobalModals(
      SCHEDULE_MODAL_TYPE,
      null,
      this.props.selectedSchedule,
      this.props.selectedScheduleEvent,
      {
        locationId, // if set, this is a calendar event
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: false,
        startDate: null,
        assignment: null,
        rescheduleDate,
      },
      this.props.modalCallback,
    );
    this.setState({ open: false })
  }

  handleManageRepeatingTask = () => {
    if (this.taskMutationPending || this.props.mutationDisabled) return;
    const {
      selectedBarn,
      selectedEvent,
      selectedSchedule,
    } = this.props;
    const tags = ((selectedSchedule && selectedSchedule.tags) || (selectedEvent && selectedEvent.tags) || []);
    const locationTag = tags.find((t) => t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId);
    const eventTypeTag = tags.find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId);
    const locationId = (eventTypeTag && (locationTag && locationTag.id)) || null;

    this.props.setGlobalModals(
      SCHEDULE_MODAL_TYPE,
      selectedEvent,
      selectedSchedule,
      null,
      {
        locationId,
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: true,
        startDate: null,
      },
      this.props.modalCallback,
    );
    this.handleClose();
  }

  render() {
    const {
      selectedEvent,
      selectedSchedule,
      selectedScheduleEvent,
      isUpdatingEvent,
      isFetchingSchedules,
      selectedBarn,
      sx,
      attachFileClick,
      permissions,
      flexDirection,
      showMore,
      openModalType,
    } = this.props;
    const { copyTask } = this.state;
    const taskBusy = isUpdatingEvent || this.state.savingTask || this.props.mutationDisabled;

    const selectedOccurrenceDate = this.getOccurrenceStartDate();
    const isCalendarEvent = (selectedScheduleEvent && selectedScheduleEvent.eventTask)
      || (selectedSchedule && selectedSchedule.tags && !!selectedSchedule.tags.find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId))
    const entityTerm = `${(!selectedEvent || !selectedEvent.id)
      ? 'Future '
      : ''}${isCalendarEvent || (selectedScheduleEvent && selectedScheduleEvent.eventTask)
        ? 'Calendar Event'
        : 'Task'}`
    const scheduleSeriesText = selectedSchedule && selectedSchedule.id && getScheduleSeriesText(selectedSchedule);
    const showManageRepeatingTask = selectedSchedule
      && scheduleSeriesText
      && openModalType === TASK_MODAL_TYPE
      && (!selectedSchedule.endDate || new Date(selectedSchedule.endDate).getTime() > new Date().getTime());
    const resourceType = (selectedScheduleEvent && selectedScheduleEvent.horseTask && 'horse')
      || (selectedScheduleEvent && selectedScheduleEvent.horseTask && 'chore') || 'task'
    const isSingleOccurrence = selectedSchedule && !selectedSchedule.parentSchedule && selectedSchedule.endDate
      && new Date(selectedSchedule.startDate).getTime() === new Date(selectedSchedule.endDate).getTime();
    const isScheduleException = selectedSchedule && selectedSchedule.parentSchedule && selectedSchedule.parentSchedule.id;
    const deleteOtherTasks = this.state.deleteOtherTasks === true || this.state.deleteOtherTasks === 'true';
    const scheduleWorkflowCount = this.getScheduleWorkflowCount();
    const hasMultipleTasksOrWorkflows = selectedSchedule && scheduleWorkflowCount > 1;
    const showDeleteWorkflowScope = hasMultipleTasksOrWorkflows && this.canDeleteSingleWorkflow();
    const onlyRemoveSelectedTask = showDeleteWorkflowScope && !deleteOtherTasks;
    const confirmCancelUpdatesInvitation = this.state.confirmCancelOccurrence
      && selectedSchedule
      && selectedSchedule.id
      && ((!isSingleOccurrence && !isScheduleException)
        || ((isScheduleException || isSingleOccurrence) && onlyRemoveSelectedTask && selectedEvent));
    const showInvitationNotificationOption = selectedSchedule
      && selectedSchedule.type === 'Invitation'
      && selectedSchedule.assignment
      && selectedSchedule.assignment.length > 0
      && (this.state.confirmEndSeries || confirmCancelUpdatesInvitation);

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection,
          gap: 1,
        }}
      >
        {this.state.mutationError && <Alert severity="error">{this.state.mutationError}</Alert>}
        {
          (taskBusy || isFetchingSchedules) && (<CircularProgress size={30} sx={sx} />)
        }
        {
          ((!this.props.editMode && !taskBusy && !isFetchingSchedules) && selectedEvent && selectedEvent.id && this.props.onEdit) && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); this.props.onEdit(e); }}
              id="menu-btn"
              aria-owns={this.state.open
                ? 'menu-appbar'
                : null}
              aria-haspopup="true"
            >
              <Icon sx={sx}>edit</Icon>
            </IconButton>
          )
        }
        {
          !(taskBusy || isFetchingSchedules) && (
            <Tooltip title="Delete Task" placement="left" disableInteractive>
              <IconButton
                onClick={(e) => { e.stopPropagation(); this.handleOpen(e, 'delete'); }}
                id="menu-btn"
                aria-owns={this.state.open
                  ? 'menu-appbar'
                  : null}
                aria-haspopup="true"
              >
                <Icon sx={sx}>delete</Icon>
              </IconButton>
            </Tooltip>
          )
        }
        {
          !(taskBusy || isFetchingSchedules) && showMore && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); this.handleOpen(e, 'more'); }}
              id="menu-btn"
              aria-owns={this.state.open
                ? 'menu-appbar'
                : null}
              aria-haspopup="true"
            >
              <Icon sx={sx}>more_vert</Icon>
            </IconButton>
          )
        }
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: -10,
            left: 0,
          }}
          open={this.state.open && this.state.dialogType === 'more'}
          onClose={(e) => { e.stopPropagation(); this.handleClose(); }}
        >
          <ListSubheader>Actions</ListSubheader>
          {
            selectedEvent && attachFileClick && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  attachFileClick();
                  this.handleClose();
                }}
              >
                <ListItemIcon>
                  <Icon>cloud_upload</Icon>
                </ListItemIcon>
                Attach File to this Task
              </MenuItem>
            )
          }
          {
            selectedSchedule && selectedSchedule.id && (
              <Divider sx={{ my: 1 }} />
            )
          }
          {
            showManageRepeatingTask && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleManageRepeatingTask();
                }}
              >
                <ListItemIcon>
                  <EventRepeat />
                </ListItemIcon>
                Manage Repeating Task
              </MenuItem>
            )
          }
          {
            selectedSchedule && selectedSchedule.id && selectedScheduleEvent && selectedScheduleEvent.id && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); this.setState({ copyTask: !copyTask });
                }}
              >
                <ListItemIcon>
                  <ContentCopy />
                </ListItemIcon>
                <Tooltip title={`Select a date to copy this ${entityTerm.replace('Future ', '').toLowerCase()} for`} sx={{ flex: 1 }}><Box>Copy {entityTerm.replace('Future ', '')}</Box></Tooltip>
                {
                  !copyTask
                    ? <ExpandMore color="secondary" />
                    : <ExpandLess color="secondary" />
                }
              </MenuItem>
            )
          }
          <Collapse in={copyTask}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                m: 2,
                gap: 1,
              }}
            >
              <Typography variant="body2" sx={{ flexBasis: '100%' }}>
                Select a date to copy this {entityTerm.replace('Future ', '').toLowerCase()} for
              </Typography>
              <Box>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mb: 0.5 }}
                  onClick={(e) => {
                    e.stopPropagation(); this.copyDateClick(moment().startOf('day'))
                  }}
                >Today
                </Button>
              </Box>
              <Box>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mb: 0.5 }}
                  onClick={(e) => {
                    e.stopPropagation(); this.copyDateClick(moment().add(1, 'days').startOf('day'))
                  }}
                >Tomorrow
                </Button>
              </Box>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileDatePicker
                  label="Select Date"
                  value={toMomentValue(moment().startOf('day'))}
                  onChange={this.copyDateClick}
                  slotProps={{
                    textField: {
                      helperText: '',
                      size: 'small',
                      sx: { maxWidth: 175 },
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Collapse>

          <Divider sx={{ my: 1 }} />

          {(selectedEvent && selectedEvent.id && !selectedEvent.archived) && (
            <Box>
              {
                selectedEvent.completeDate
                  ? (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation(); this.handleEventStatus({ completeEvent: false });
                      }}
                    >
                      <ListItemIcon>
                        <Update />
                      </ListItemIcon>
                      Mark Uncomplete
                    </MenuItem>
                  )
                  : (
                    <MenuItem
                      onClick={(e) => {
                        e.stopPropagation(); this.handleEventStatus({ completeEvent: true });
                      }}
                    >
                      <ListItemIcon>
                        <CheckBox color="primary" />
                      </ListItemIcon>
                      Mark Complete
                    </MenuItem>
                  )
              }
            </Box>
          )}

          {
            selectedEvent && selectedEvent.archived && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); this.handleArchiveEvent({ archived: false });
                }}
              >
                <ListItemIcon>
                  <Icon>restore_from_trash</Icon>
                </ListItemIcon>
                Restore Task
              </MenuItem>
            )
          }

          {
            (permissions.owner || permissions.admin) && (
              <Divider sx={{ my: 1 }} />
            )
          }
          {
            (permissions.owner || permissions.admin) && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation(); window.location.href = `/settings/${(isCalendarEvent && 'calendar') || 'tasks'}/${(selectedEvent && selectedEvent.eventTemplateId) || (selectedSchedule && selectedSchedule.eventTemplate && selectedSchedule.eventTemplate.id)}`;
                }}
              >
                <ListItemIcon>
                  <Icon>settings</Icon>
                </ListItemIcon>
                Manage {entityTerm.replace('Future ', '')} Type Settings
              </MenuItem>
            )
          }

        </Menu>
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: -10,
            left: 0,
          }}
          open={this.state.open && this.state.dialogType === 'assignment'}
          onClose={(e) => { e.stopPropagation(); this.handleClose(); }}
        >
          <Box sx={{ width: 300 }}>
            <BarnUsersAutocomplete
              label="Task Assignment"
              id="barn-users-task-options-autocomplete-assignment"
              multiple
              autoFocus
              blurOnSelect={!((selectedEvent && selectedEvent.currentEventStatus && selectedEvent.currentEventStatus.assignment))}
              size="small"
              value={getBarnUsersForAssignmentString((selectedEvent && selectedEvent.currentEventStatus && selectedEvent.currentEventStatus.assignment) || '', {})}
              onSelect={(e, newBarnUsers) => {
                const newAssignment = newBarnUsers.map((bu) => (bu.id
                  ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                  : `@[${bu.userFullName || bu}](${null})`)).join('');
                // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
                this.handleNewAssignment(newAssignment)
              }}
              limitTags={5}
            // suggestAssignmentHorseTagId,
            // suggestParticipantHorseTagId,
            />
          </Box>
        </Menu>
        <Dialog
          open={this.state.open && this.state.dialogType === 'delete'}
          onClose={(e) => {
            e.stopPropagation();
            this.setState({
              open: false,
              confirmCancelOccurrence: false,
              confirmCancelSeries: false,
              confirmEndSeries: false,
              sendInvitationNotifications: true,
              dialogType: 'more',
            })
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Delete {entityTerm} {selectedOccurrenceDate && `(${moment(selectedOccurrenceDate).format('ll')})`}
          </DialogTitle>
          <DialogContent sx={{ minWidth: 300 }}>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {
                  !showDeleteWorkflowScope && (
                    <Box sx={{ ml: 1 }}>
                      <TagList
                        tags={((selectedEvent && selectedEvent.tags) || (selectedSchedule && selectedSchedule.tags) || [])
                          .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                            || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                      />
                    </Box>
                  )
                }
                <FormControlLabel
                  sx={{ m: 0 }}
                  control={(
                    <Radio
                      checked={this.state.confirmCancelOccurrence}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({
                          confirmCancelOccurrence: true,
                          confirmCancelSeries: false,
                          confirmEndSeries: false,
                          sendInvitationNotifications: true,
                        })
                      }}
                    />
                  )}
                  label={`This ${isCalendarEvent
                    ? 'calendar event'
                    : 'task'}${scheduleSeriesText
                      ? ' occurrence'
                      : ''}`}
                />

                {
                  scheduleSeriesText && (
                    <FormControlLabel
                      sx={{ m: 0 }}
                      control={(
                        <Radio
                          checked={this.state.confirmEndSeries}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              confirmCancelOccurrence: false,
                              confirmCancelSeries: false,
                              confirmEndSeries: true,
                            })
                          }}
                        />
                      )}
                      label={`This and following ${isCalendarEvent
                        ? 'calendar events'
                        : 'tasks'}`}
                    />
                  )
                }
                {
                  scheduleSeriesText && (
                    <FormControlLabel
                      sx={{ m: 0 }}
                      control={(
                        <Radio
                          checked={this.state.confirmCancelSeries}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              confirmCancelOccurrence: false,
                              confirmCancelSeries: true,
                              confirmEndSeries: false,
                              sendInvitationNotifications: true,
                            })
                          }}
                        />
                      )}
                      label={`All ${isCalendarEvent
                        ? 'calendar events'
                        : 'tasks'}`}
                    />
                  )
                }
              </RadioGroup>
              <FormHelperText>
                {this.state.confirmCancelSeries && (
                  `All occurrences of this ${resourceType} will be deleted. This Action cannot be undone.`
                )}
                {this.state.confirmEndSeries && (
                  `The repeating ${resourceType} series will end ${moment((this.props.selectedScheduleEvent && this.props.selectedScheduleEvent.start
                    && moment(this.props.selectedScheduleEvent.start).toDate()) || new Date()).format('ll')}. Previous ${entityTerm.replace('Future ', '')}s will remain but future scheduled ${entityTerm.replace('Future ', '')}s will be removed.`
                )}
              </FormHelperText>
            </FormControl>
            {
              showInvitationNotificationOption && (
                <Box sx={{ mt: 1 }}>
                  <FormControlLabel
                    label="Email updated invitation to participants"
                    sx={{ m: 0 }}
                    control={(
                      <Checkbox
                        size="small"
                        checked={this.state.sendInvitationNotifications}
                        onChange={(e) => {
                          this.setState({ sendInvitationNotifications: e.target.checked })
                        }}
                        inputProps={{ 'aria-label': 'Email updated invitation to participants' }}
                      />
                    )}
                  />
                </Box>
              )
            }

            {
              showDeleteWorkflowScope
                ? (
                  <Box sx={{ m: 2 }}>
                    <Alert severity="info">
                      {scheduleWorkflowCount - 1} other {resourceType}{scheduleWorkflowCount === 2
                        ? ' was '
                        : 's were '} planned along with this {resourceType}. How would
                      you like to proceed with your delete request?
                    </Alert>

                    <FormControl sx={{ ml: 2 }}>
                      <RadioGroup
                        aria-labelledby="radio-other-tasks-group-label"
                        name="radio-buttons-other-tasks-group"
                        value={(this.state.deleteOtherTasks === true || this.state.deleteOtherTasks === 'true')
                          ? 'all'
                          : 'this'}
                        onChange={(e) => {
                          this.setState({ deleteOtherTasks: e.target.value === 'all' })
                        }}
                      >
                        <FormControlLabel
                          sx={{ m: 0 }}
                          value="this"
                          control={(<Radio size="small" />)}
                          label={`Only this ${resourceType}`}
                        />
                        <Box sx={{ ml: 4 }}>
                          <TagList
                            tags={((selectedEvent && selectedEvent.tags) || (selectedSchedule && selectedSchedule.tags) || [])
                              .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                                || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                          />
                        </Box>
                        <FormControlLabel
                          sx={{ m: 0 }}
                          value="all"
                          control={(<Radio size="small" />)}
                          label={`All ${scheduleWorkflowCount} ${resourceType}s`}
                        />
                        <Box sx={{ ml: 4 }}>
                          <TagList
                            tags={((selectedSchedule && selectedSchedule.tags) || [])
                              .filter((t) => t.tagType.id === selectedBarn.barnMetadata.horseTagTypeId
                                || t.tagType.id === selectedBarn.barnMetadata.locationTagTypeId)}
                          />
                        </Box>
                      </RadioGroup>
                    </FormControl>
                    <Divider sx={{ my: 1 }} />
                  </Box>
                )
                : <Box />
            }
          </DialogContent>
          <DialogActions
            sx={{
              alignItems: 'flex-end',
              flexWrap: 'wrap',
              gap: 2,
              px: 3,
              pb: 3,
            }}
          >
            {
              scheduleSeriesText && (
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 280,
                  }}
                >
                  <em>
                    <Typography
                      sx={{
                        p: 2,
                        fontSize: 12,
                      }}
                    >&#42;This {entityTerm} is part of a recurring series of {resourceType}s,{' '}
                      repeating {scheduleSeriesText}.
                    </Typography>
                  </em>
                </Box>
              )
            }
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexShrink: 0,
                gap: 2,
              }}
            >
              <Button
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    open: false,
                    confirmCancelOccurrence: false,
                    confirmCancelSeries: false,
                    confirmEndSeries: false,
                    sendInvitationNotifications: true,
                    dialogType: 'more',
                  })
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  minWidth: 168,
                  whiteSpace: 'nowrap',
                }}
                loading={(taskBusy || isFetchingSchedules)}
                disabled={!this.state.confirmCancelOccurrence && !this.state.confirmCancelSeries && !this.state.confirmEndSeries}
                onClick={(e) => {
                  e.stopPropagation();
                  if (this.state.confirmCancelOccurrence) {
                    this.handleConfirmDeleteOccurrence()
                  } else if (this.state.confirmCancelSeries) {
                    this.handleConfirmDeleteSeries();
                  } else if (this.state.confirmEndSeries) {
                    this.handleConfirmEndSeries();
                  }
                }}
              >
                Confirm Delete
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

EventActionsMenuComponent.propTypes = {
  selectedEvent: PropTypes.object,
  selectedSchedule: PropTypes.object,
  selectedScheduleEvent: PropTypes.object,
  eventTasks: PropTypes.array,

  attachFileClick: PropTypes.func,

  isUpdatingEvent: PropTypes.bool,
  patchEvent: PropTypes.func,

  sx: PropTypes.object,
  changeStatus: PropTypes.func,
  addScheduleException: PropTypes.func,
  deleteSchedule: PropTypes.func,
  updateSchedule: PropTypes.func,
  selectedBarn: PropTypes.object,
  setGlobalModals: PropTypes.func,
  modalCallback: PropTypes.func,
  getEvent: PropTypes.func,
  isFetchingSchedules: PropTypes.bool,
  permissions: PropTypes.object,
  onClose: PropTypes.func,
  onMutationChange: PropTypes.func,
  mutationDisabled: PropTypes.bool,
  onEdit: PropTypes.func,
  editMode: PropTypes.bool,
  flexDirection: PropTypes.string,
  showMore: PropTypes.bool,
  openModalType: PropTypes.string,
};

EventActionsMenuComponent.defaultProps = {
  selectedEvent: null,
  selectedSchedule: null,
  selectedScheduleEvent: null,
  eventTasks: [],

  attachFileClick: null,

  isUpdatingEvent: false,
  isFetchingSchedules: false,

  patchEvent: () => { },
  sx: { color: '#fff' },
  changeStatus: () => { },
  addScheduleException: () => { },
  deleteSchedule: () => { },
  updateSchedule: () => { },
  getEvent: () => { },
  setGlobalModals: () => { },
  modalCallback: () => { },
  selectedBarn: {},
  permissions: {},
  onClose: () => { },
  onMutationChange: () => { },
  mutationDisabled: false,
  onEdit: null,
  editMode: false,
  flexDirection: 'row',
  showMore: false,
  openModalType: null,
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  selectedSchedule: state.schedule.schedule,
  selectedScheduleEvent: state.schedule.event,
  eventTasks: state.schedule.eventTasks,

  isUpdatingEvent: state.event.isUpdatingEvent || state.event.isChangingStatus,
  isFetchingSchedules: state.schedule.isFetchingSchedules,

  canAttachFiles: (state.tenant.tenant && state.tenant.tenant.stripePlan !== null),
  selectedBarn: state.barn.selectedBarn,
  permissions: state.user.permissions,
  modalCallback: state.app.modalCallback,
  openModalType: state.app.openModalType,
});

export const mapDispatchToProps = (dispatch) => ({
  patchEvent: (id, request) => dispatch(patchEvent(id, request)),
  changeStatus: (id, request) => dispatch(changeEventStatus(id, request)),
  editEventStatus: (id, request) => dispatch(editEventStatus(id, request)),
  addScheduleException: (id, request, skipInvitationNotifications) => dispatch(addScheduleException(id, request, skipInvitationNotifications)),
  deleteSchedule: (id) => dispatch(deleteSchedule(id)),
  updateSchedule: (id, request, skipInvitationNotifications) => dispatch(updateSchedule(id, request, skipInvitationNotifications)),
  getEvent: (id) => dispatch(getEvent(id)),
  setGlobalModals: (t, e, s, ee, c, cc) => dispatch(setGlobalModals(t, e, s, ee, c, cc)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventActionsMenuComponent);
